export const APPEND_LIST = 'APPEND_LIST';
export const GET_COURSE_LIST = 'GET_COURSE_LIST';
export const RESET_LISTS = 'RESET_LISTS'; // 重置列表
